



































import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import { isMediaFile } from "@/lib/fileHelpers";
import BaseIcon from "@/components/BaseIcon";
import ContentFeedBaseView from "./components/ContentFeedBaseView";
import ContentFeedFileList from "./components/ContentFeedFileList";
import ContentFeedGallery from "./components/ContentFeedGallery";
import ContentFeedLocked from "./components/ContentFeedLocked";
import FeedItemMixin from "./mixins/FeedItemMixin";
import { ProcessedContentFiles } from "./";

@Component({
  name: "ContentFeedItem",
  components: {
    ContentFeedLocked,
    ContentFeedFileList,
    ContentFeedBaseView,
    ContentFeedGallery,
    BaseIcon,
  },
})
export default class ContentFeedItem extends mixins(FeedItemMixin, WithAuthUser) {
  @Prop({ type: Array, required: true })
  public readonly subscriptionLevels!: SubscriptionLevel[];

  @Prop({ type: Array, required: true })
  public readonly paymentPackages!: PaymentPackage[];

  @Prop({ type: Boolean, default: false })
  public readonly showFollowButton!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showReportItem!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showComment!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showFooter!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showShare!: boolean;

  public get processedFiles() {
    return this.contentFeed.files.reduce<{ documents: ProcessedContentFiles; media: ProcessedContentFiles }>(
      (out, f) => {
        const key = isMediaFile(f) ? "media" : "documents";
        const accessKey = this.hasAccessToFile(f) ? "accessed" : "locked";
        out[key].all.push(f);
        out[key][accessKey].push(f);
        return out;
      },
      {
        documents: { locked: [], accessed: [], all: [] },
        media: { locked: [], accessed: [], all: [] },
      }
    );
  }

  public get allFilesLocked() {
    return (
      this.contentFeed.files.length > 0 &&
      this.processedFiles.documents.accessed.length === 0 &&
      this.processedFiles.media.accessed.length === 0
    );
  }

  public hasAccessToFile(f: ContentFile) {
    return (
      (this.authUser && this.authUser.id === this.contentFeed.userId) || this.contentFeed.purchased || f.publicAccess
    );
  }
}
